import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { QRCode } from 'react-qr-svg';
import Barcode from 'react-barcode';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { FloatingModal } from '../Modal';
import { isMobile } from '../../../../mobile/helpers';
import Button from '../Button';
import styles from './ticket-list.scss';

const propTypes = {
  event: PropTypes.shape(),
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  ticket: PropTypes.shape(),
  ticketCode: PropTypes.shape({
    text: PropTypes.string,
    type: PropTypes.string,
    code: PropTypes.string,
  }),
};

class TicketModal extends Component {
  static getDerivedStateFromProps = (props, state) => {
    const { ticket, user, isOpen } = props;
    const { ticket: prevTicket, user: prevUser, isOpen: prevIsOpen } = state;

    if (ticket !== prevTicket || user !== prevUser || isOpen !== prevIsOpen) {
      return {
        ticket,
        user,
        isOpen,
        blurred: ticket.claimed_by && ticket.claimed_by !== user.id,
      };
    }

    return {};
  }

  constructor(props) {
    super(props);

    this.state = {
      blurred: false,
    };
  }

  render() {
    const {
      event,
      isOpen,
      onRequestClose,
      ticket,
      ticketCode,
    } = this.props;

    const {
      blurred,
    } = this.state;

    return (
      <FloatingModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        buttonText="Close"
      >
        <div className={styles.ticket}>
          { ticketCode
            ? (
              <>
                <div
                  className={styles.bigCode}
                  onClick={() => this.setState({ blurred: false })}
                  role="button"
                  tabIndex="-1"
                >
                  {blurred && (
                  <div className={styles.message}>
                    This ticket has been added to {ticket.ticketHolder}&apos;s account.
                    Tap once to show the code anyway.
                  </div>
                  )}
                  <div className={classnames(styles.qr, blurred && styles.blurred)}>
                    { ticketCode.type === 'bar'
                      ? <Barcode value={ticketCode.code} />
                      : (
                        <QRCode
                          bgColor="#FFFFFF"
                          fgColor="#000000"
                          level="Q"
                          style={{ width: 200, maxWidth: '100%' }}
                          value={ticketCode.code}
                        />
                      )}
                  </div>
                  <div className={styles.textCode}>
                    {ticketCode.text}
                  </div>
                </div>
              </>
            )
            : (
              <>
                <div className={classnames(styles.bigCode, styles.blurred)}>
                  <QRCode
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                    level="Q"
                    style={{ width: 200, maxWidth: '100%' }}
                    value="Checkin with the DreamHack app is unfortunately not possible. Please refer to the ticket provider of the event to see your checkin code."
                  />
                </div>
                <div className={styles.message}>
                  Checkin with the DreamHack app is unfortunately not possible.
                  Please refer to the ticket provider of the event to see your checkin code.
                </div>
              </>
            )}
          <div className={styles.name}>
            {`${ticket.ticketHolder}`}
          </div>
          <div className={styles.seat}>
            { ticket.ticket_type
              && (
              <div className={styles.type}>
                {ticket.ticket_type.name}
              </div>
              )}
            { !event && ticket.ticket_type
              && (
              <div className={styles.place}>
                <i className="far fa-calendar-alt" />
                {' '}
                {ticket.ticket_type.event.name}
                {' '}
              </div>
              )}
            { ticket?.addons
              && (
                <>
                  {ticket.addons.map((addon) => (
                    <p>{addon.name}: {addon.value}</p>
                  ))}
                </>
              )}
            { ticket.expanded_seat
              && (
                <>
                  <div className={styles.place}>
                    <i className="far fa-map" />
                    {' '}
                    {
                    // If we're looking at a ticket for montreal 19 - use section name
                    // as floor name.
                    ((event && event.id === 'e04cdf59-11b4-4040-bb87-c25ca8678851') || (ticket?.ticket_type?.event?.id === 'e04cdf59-11b4-4040-bb87-c25ca8678851'))
                      ? ticket.expanded_seat.expanded_row.expanded_section.name
                      : ticket.expanded_seat.expanded_row.expanded_section.floor.name
                  }
                  </div>
                  <div className={styles.place}>
                    <i className="far fa-map-marker" />
                    {' '}
                    {`${ticket.expanded_seat.expanded_row.name}:${ticket.expanded_seat.name}`}
                  </div>
                </>
              )}
          </div>
          {ticket && ticket.ticket_type && ticket.ticket_type.event && (
            <>
              { isMobile()
                ? (
                  <div className={styles.manage}>
                    <Button
                      outline
                      onClick={() => window.open(`https://dreamhack.com/tickets/${ticket.ticket_type.event.shortcode}`)}
                    >
                      <i className="far fa-cog" />
                      {' '}
                      Manage
                    </Button>
                  </div>
                )
                : (
                  <div className={styles.manage}>
                    <Link to={`/tickets/${ticket.ticket_type.event.shortcode}`}>
                      <Button outline>
                        <i className="far fa-cog" />
                        {' '}
                        Manage
                      </Button>
                    </Link>
                  </div>
                )}
            </>
          )}
        </div>
      </FloatingModal>

    );
  }
}

TicketModal.propTypes = propTypes;

export default TicketModal;
